import { inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { MENU_TOKEN } from '@core/token/menu.token';
import { MenuItem } from 'primeng/api';

const MENU_KEY = makeStateKey<MenuItem[]>('menu');

export function menuResolver(): MenuItem[] {
  let menu = inject(MENU_TOKEN);
  const platform = inject(PLATFORM_ID);
  const transferState = inject(TransferState);

  if (isPlatformServer(platform)) {
    transferState.set(MENU_KEY, menu);
    return menu;
  }

  menu = transferState.get(MENU_KEY, []);

  return menu;
}
